// src/baseUrl.js (frontend-ext)

let ENTRANCE_URL = ''

switch (process.env.VUE_APP_MODE) {
  case 'development':
  case 'eduslim':
    ENTRANCE_URL = 'https://test-doatap.minedu.gov.gr'
    // ENTRANCE_URL = 'https://eduslim1.minedu.gov.gr'
    break
  case 'dev-vimasrv001':
  case 'vimasrv001':
    // ENTRANCE_URL = 'http://vimasrv001.minedu.gov.gr:8080'
    // ENTRANCE_URL = 'http://vimasrv012.minedu.gov.gr:8999'
    ENTRANCE_URL = 'http://vimasrv002.minedu.gov.gr:7000' // Maria
    break
  case 'dev-vimasrv002':
  case 'vimasrv002':
    // ENTRANCE_URL = 'http://vimasrv002.minedu.gov.gr:8801'
    // ENTRANCE_URL = 'http://vimasrv002.minedu.gov.gr:8851'
    // ENTRANCE_URL = 'http://vimasrv002.minedu.gov.gr:8901'
    // ENTRANCE_URL = 'http://vimasrv002.minedu.gov.gr:7000' // Maria, since 2025-09-03
    ENTRANCE_URL = 'http://vimasrv002.minedu.gov.gr:7500' // Panagiotis
    // BASE_URL = 'http://83.212.170.136:7500/api' // Panagiotis
    break
  case 'production':
  default:
    ENTRANCE_URL = 'https://e-doatap.doatap.gr'
    break
}

let BASE_URL = ''

switch (process.env.VUE_APP_MODE) {
  case 'dev-vimasrv001':
  case 'vimasrv001':
  case 'dev-vimasrv002':
  case 'vimasrv002':
    BASE_URL = ENTRANCE_URL + '/api'
    break
  case 'development':
  case 'eduslim':
  case 'production':
  default:
    BASE_URL = ENTRANCE_URL + '/laravel/public/api'
    break
}

export { ENTRANCE_URL, BASE_URL }
